<template>
  <core-view class="flex-column" fill-height>
    <div v-if="!loading" class="center">
      <v-form ref="form" v-model="formValido" lazy-validation>

        <!-- 1. Data e Hora -->
        <div class="linha mb-3">
          <core-date-time-picker-field
            hide-details
            form
            v-model="formulario.dataHora"
            :label="['Data', 'Hora']"
            :rules="rules.dataHora"
          />
        </div>

        <!-- 2. Placas -->
        <div class="linha mb-4">
          <v-combobox
            outlined
            :dense="!$vuetify.breakpoint.mobile"
            background-color="white"
            label="Placas"
            v-model="formulario.placa"
            :items="autocomplete.frota"
            :item-text="$_formatarItemFrota"
            item-value="id"
            return-object
            :rules="rules.placa"
            clearable
            :filter="$_filtroFrota"
            append-icon="mdi-dots-horizontal-circle-outline"
            @click:append="$_abrirTelaSelecao('placa')"
            :search-input.sync="comboboxSearch.placa"
            @blur="$_onComboboxBlur('placa')"
            @click:clear="comboboxSearch.placa = ''"
            hide-details="auto"
            placeholder="Informe ou selecione a placa..."
            no-data-text="Nenhum veículo encontrado. O valor digitado será utilizado."
          />
        </div>

        <!-- 3. Motorista -->
        <div class="linha mb-4">
          <v-combobox
            outlined
            :dense="!$vuetify.breakpoint.mobile"
            background-color="white"
            label="Motorista"
            v-model="formulario.motorista"
            :items="autocomplete.motorista"
            :item-text="$_formatarItemPessoa"
            item-value="id"
            return-object
            :rules="rules.motorista"
            clearable
            :filter="$_filtroPessoa"
            append-icon="mdi-dots-horizontal-circle-outline"
            @click:append="$_abrirTelaSelecao('motorista')"
            :search-input.sync="comboboxSearch.motorista"
            @blur="$_onComboboxBlur('motorista')"
            @click:clear="comboboxSearch.motorista = ''"
            hide-details="auto"
            placeholder="Informe ou selecione o motorista..."
            no-data-text="Nenhum motorista encontrado. O valor digitado será utilizado."
          />
        </div>

        <!-- 4. Contrato MP -->
        <div class="linha mb-4">
          <v-text-field
            outlined
            :dense="!$vuetify.breakpoint.mobile"
            background-color="white"
            label="Contrato MP"
            v-model="formulario.contratoMp"
            :rules="rules.contratoMp"
            hide-details="auto"
            clearable
            placeholder="Informe o número do contrato MP..."
          />
        </div>

        <!-- 5. Produtor -->
        <div class="linha mb-4">
          <v-combobox
            outlined
            :dense="!$vuetify.breakpoint.mobile"
            background-color="white"
            label="Produtor"
            v-model="formulario.produtor"
            :items="autocomplete.produtor"
            :item-text="$_formatarItemPessoa"
            item-value="id"
            return-object
            :rules="rules.produtor"
            clearable
            :filter="$_filtroPessoa"
            append-icon="mdi-dots-horizontal-circle-outline"
            @click:append="$_abrirTelaSelecao('produtor')"
            :search-input.sync="comboboxSearch.produtor"
            @blur="$_onComboboxBlur('produtor')"
            @click:clear="comboboxSearch.produtor = ''"
            hide-details="auto"
            placeholder="Informe ou selecione o produtor..."
            no-data-text="Nenhum produtor encontrado. O valor digitado será utilizado."
          />
        </div>

        <!-- 6. Propriedade -->
        <div class="linha mb-4">
          <v-combobox
            outlined
            :dense="!$vuetify.breakpoint.mobile"
            background-color="white"
            label="Propriedade"
            v-model="formulario.propriedade"
            :items="autocomplete.propriedade"
            :item-text="$_formatarItemPropriedade"
            item-value="id"
            return-object
            :rules="rules.propriedade"
            clearable
            :filter="$_filtroPropriedade"
            append-icon="mdi-dots-horizontal-circle-outline"
            @click:append="$_abrirTelaSelecao('propriedade')"
            :search-input.sync="comboboxSearch.propriedade"
            @blur="$_onComboboxBlur('propriedade')"
            @click:clear="comboboxSearch.propriedade = ''"
            hide-details="auto"
            placeholder="Informe ou selecione a propriedade..."
            no-data-text="Nenhuma propriedade encontrada. O valor digitado será utilizado."
          />
        </div>

        <!-- 7. Produto -->
        <div class="linha mb-4">
          <v-combobox
            outlined
            :dense="!$vuetify.breakpoint.mobile"
            background-color="white"
            label="Produto"
            v-model="formulario.produto"
            :items="autocomplete.produto"
            :item-text="$_formatarItemProduto"
            item-value="id"
            return-object
            :rules="rules.produto"
            clearable
            :filter="$_filtroProduto"
            append-icon="mdi-dots-horizontal-circle-outline"
            @click:append="$_abrirTelaSelecao('produto')"
            :search-input.sync="comboboxSearch.produto"
            @blur="$_onComboboxBlur('produto')"
            @click:clear="comboboxSearch.produto = ''"
            hide-details="auto"
            placeholder="Informe ou selecione o produto..."
            no-data-text="Nenhum produto encontrado. O valor digitado será utilizado."
          />
        </div>

        <!-- 8. Talhão -->
        <div class="linha mb-4">
          <v-combobox
            outlined
            :dense="!$vuetify.breakpoint.mobile"
            background-color="white"
            label="Talhão"
            v-model="formulario.talhao"
            :items="autocomplete.talhao"
            :item-text="$_formatarItemTalhao"
            item-value="id"
            return-object
            :rules="rules.talhao"
            clearable
            :filter="$_filtroTalhao"
            append-icon="mdi-dots-horizontal-circle-outline"
            @click:append="$_abrirTelaSelecao('talhao')"
            :search-input.sync="comboboxSearch.talhao"
            @blur="$_onComboboxBlur('talhao')"
            @click:clear="comboboxSearch.talhao = ''"
            hide-details="auto"
            placeholder="Informe ou selecione o talhão..."
            no-data-text="Nenhum talhão encontrado. O valor digitado será utilizado."
          />
        </div>

        <!-- 9. Destino -->
        <div class="linha mb-4">
          <v-combobox
            outlined
            :dense="!$vuetify.breakpoint.mobile"
            background-color="white"
            label="Destino"
            v-model="formulario.destino"
            :items="autocomplete.destino"
            :item-text="$_formatarItemDestino"
            :rules="rules.destino"
            hide-details="auto"
            clearable
            append-icon="mdi-dots-horizontal-circle-outline"
            :search-input.sync="comboboxSearch.destino"
            @blur="$_onComboboxBlur('destino')"
            @click:clear="comboboxSearch.destino = ''"
            placeholder="Informe ou selecione o destino..."
            no-data-text="Nenhum destino sugerido. O valor digitado será utilizado."
          />
        </div>

        <!-- Observação Opcional -->
        <div class="linha mb-4">
          <v-textarea
            outlined
            dense
            background-color="white"
            label="Observação"
            rows="2"
            counter="300"
            maxlength="300"
            v-model="formulario.observacao"
            hide-details="auto"
            placeholder="Observações adicionais sobre o embarque..."
          />
        </div>

        <!-- SEÇÃO: LOCALIZAÇÃO E FOTOS -->
        <div class="secao-anexos mb-4">
          <div class="text-caption font-weight-bold grey--text text--darken-2 mb-2">
            LOCALIZAÇÃO E REGISTRO FOTOGRÁFICO
          </div>

          <!-- Botões Câmera, Gravação e Galeria (Padrão visitainfo) -->
          <div class="linha mb-3">
            <v-btn
              color="green"
              class="white--text botaocamera"
              title="Tirar Foto"
              @click="$_cliqueCamera('', true)"
            >
              <v-icon large> mdi-camera </v-icon>
            </v-btn>
            <!-- Gravação de Vídeo -->
            <v-btn
              color="green"
              class="white--text botaocamera"
              title="Gravar Vídeo"
              @click="$_cliqueGravacao('')"
            >
              <v-icon large> mdi-film </v-icon>
            </v-btn>
            <!-- Seleção de Fotos da Galeria -->
            <v-btn
              color="green"
              class="white--text botaocamera"
              title="Selecionar Fotos da Galeria"
              @click="$_abrirGaleria"
            >
              <v-icon large> mdi-image-multiple </v-icon>
            </v-btn>
          </div>

          <!-- Input oculto para seleção de fotos da galeria -->
          <input
            ref="inputGaleria"
            type="file"
            accept="image/*"
            multiple
            style="display: none;"
            @change="$_onFotosSelecionadas"
          />

          <!-- Botão de Localização GPS -->
          <div class="mb-3">
            <v-btn
              outlined
              block
              :color="formulario.localizacao ? 'green darken-2' : 'primary'"
              class="text-none font-weight-bold"
              :height="alturaCampos"
              :loading="obtendoLocalizacao"
              @click="$_obterLocalizacao"
            >
              <v-icon left>
                {{ formulario.localizacao ? 'mdi-check-circle' : 'mdi-crosshairs-gps' }}
              </v-icon>
              {{ formulario.localizacao ? 'Localização Atualizada' : 'Obter Localização' }}
            </v-btn>
          </div>

          <!-- Card de Localização Capturada -->
          <v-card
            v-if="formulario.localizacao"
            outlined
            class="pa-3 mb-3 card-localizacao"
          >
            <div class="d-flex justify-space-between align-center">
              <div class="d-flex align-center">
                <v-icon color="green darken-2" class="mr-2">mdi-map-marker-check</v-icon>
                <div>
                  <div class="text-caption font-weight-bold">
                    Lat: {{ formulario.localizacao.latitude }}, Long: {{ formulario.localizacao.longitude }}
                  </div>
                </div>
              </div>
              <div class="d-flex align-center">
                <!-- <v-btn
                  icon
                  small
                  color="primary"
                  title="Abrir no Google Maps"
                  @click="$_abrirMapa"
                >
                  <v-icon small>mdi-open-in-new</v-icon>
                </v-btn> -->
                <v-btn
                  icon
                  small
                  color="red darken-1"
                  title="Remover Localização"
                  @click="$_removerLocalizacao"
                >
                  <v-icon small>mdi-close</v-icon>
                </v-btn>
              </div>
            </div>
          </v-card>

          <!-- Galeria de Fotos / Mídias Adicionadas -->
          <div v-if="formulario.fotos && formulario.fotos.length > 0" class="fotos-galeria-container mb-3">
            <div class="text-caption font-weight-bold grey--text text--darken-2 mb-2">
              Mídias Anexadas ({{ formulario.fotos.length }})
            </div>
            <div class="d-flex flex-wrap">
              <div
                v-for="(foto, idx) in formulario.fotos"
                :key="foto.id || idx"
                class="foto-item-wrapper mr-2 mb-2"
              >
                <v-card class="foto-card elevation-2" @click="$_visualizarFoto(foto)">
                  <template v-if="foto.tipo === 'video' || foto.blob">
                    <div
                      class="d-flex flex-column align-center justify-center grey darken-3 text-center"
                      style="width: 80px; height: 80px; border-radius: 6px;"
                    >
                      <v-icon color="white" large>mdi-play-circle</v-icon>
                      <span class="white--text text-caption" style="font-size: 10px !important;">Vídeo</span>
                    </div>
                  </template>
                  <template v-else>
                    <v-img
                      :src="foto.url || foto.src"
                      height="80"
                      width="80"
                      cover
                      class="foto-miniatura"
                    >
                      <template v-slot:placeholder>
                        <v-row class="fill-height ma-0" align="center" justify="center">
                          <v-progress-circular indeterminate color="green" size="20" width="2" />
                        </v-row>
                      </template>
                    </v-img>
                  </template>
                  <v-btn
                    icon
                    x-small
                    color="white"
                    class="btn-fechar-foto"
                    title="Excluir mídia"
                    @click.stop="$_removerFoto(idx)"
                  >
                    <v-icon x-small>mdi-close</v-icon>
                  </v-btn>
                </v-card>
              </div>
            </div>
          </div>
        </div>

        <!-- BOTÕES DE AÇÃO: SALVAR E CANCELAR -->
        <div class="divinferior">
          <v-btn
            :height="alturaCampos"
            color="grey darken-1"
            class="botaoinferior botaocancelar"
            @click="$_cancelar"
          >
            <v-icon left>mdi-close</v-icon>
            Cancelar
          </v-btn>

          <v-btn
            :height="alturaCampos"
            color="green"
            class="botaoinferior botaosalvar"
            :loading="salvando"
            @click="$_salvaDados"
          >
            <v-icon left>mdi-check</v-icon>
            Salvar
          </v-btn>
        </div>

      </v-form>
    </div>

    <!-- Indicador de Carregamento Geral -->
    <div v-else class="text-center my-10">
      <v-progress-circular indeterminate color="green" size="48"></v-progress-circular>
      <p class="mt-3 text-caption grey--text">Carregando formulário de embarque...</p>
    </div>

    <!-- Modal de Foto / Vídeo Ampliado -->
    <v-dialog v-model="dialogFotoAmpliada" max-width="600px">
      <v-card v-if="fotoSelecionada">
        <v-card-title class="py-2 px-3 d-flex justify-space-between align-center">
          <span class="text-caption font-weight-bold grey--text text--darken-3">
            {{ fotoSelecionada.nome || 'Visualização da Mídia' }}
          </span>
          <v-btn icon small @click="dialogFotoAmpliada = false">
            <v-icon small>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text class="pa-2 text-center">
          <video
            v-if="fotoSelecionada.tipo === 'video' || fotoSelecionada.blob"
            :src="fotoSelecionada.mediaUrl || fotoSelecionada.url || fotoSelecionada.src"
            controls
            style="max-width: 100%; max-height: 75vh;"
            class="mx-auto"
          />
          <v-img
            v-else
            :src="fotoSelecionada.mediaUrl || fotoSelecionada.url || fotoSelecionada.src"
            contain
            max-height="75vh"
            class="mx-auto"
          />
          <div class="text-caption grey--text mt-2" v-if="fotoSelecionada.dataHora">
            Capturada em: {{ fotoSelecionada.dataHora }}
          </div>
          <div class="text-caption grey--text text--darken-2 mt-1" v-if="fotoSelecionada.descricao">
            {{ fotoSelecionada.descricao }}
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- Dialog Confirmar Cancelamento se houver dados -->
    <v-dialog v-model="dialogConfirmarCancelar" width="400">
      <v-card>
        <v-card-title class="text-subtitle-1 grey lighten-3 py-3 px-4">
          <span>Descartar Alterações</span>
          <v-spacer></v-spacer>
          <v-icon color="amber darken-2">mdi-alert-outline</v-icon>
        </v-card-title>
        <v-card-text class="pt-4 pb-2">
          Existem dados preenchidos no formulário. Deseja realmente cancelar e descartar as informações?
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions class="pa-3 d-flex justify-end">
          <v-btn text color="grey darken-1" @click="dialogConfirmarCancelar = false">
            Continuar Editando
          </v-btn>
          <v-btn color="red darken-1" text @click="$_confirmarSair">
            Sim, Descartar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

  </core-view>
</template>

<script>
import CoreView from '@/components/core/view/Index.vue';
import CoreDateTimePickerField from '@/components/core/variant/date-time-picker-field variant/Index.vue';
import moment from 'moment-timezone';
import geraData from '@/utils/geradata';
import errorHandler from '@/utils/error-handler';
import db from '@/plugins/dexie';
import {
  ROUTE_APONTAMENTO_EMBARQUE,
  ROUTE_APONTAMENTO_EMBARQUE_CADASTRO,
  ROUTE_APONTAMENTO_EMBARQUE_SELECAO,
  ROUTE_CAMERA,
  ROUTE_VIDEO,
} from '@/constants/ROUTES';
import {
  APONTAMENTO_EMBARQUE_STORAGE,
  MANUTENCAO_STORAGE,
  ROTA_STORAGE,
  VISITA_INFO_STORAGE,
} from '@/constants/STORAGE';
import { setVideoBlob, getVideoBlob, removeVideoBlob } from '@/utils/local/apontamentoVideoBlobs';

export default {
  name: 'ViewApontamentoEmbarqueCadastro',

  components: {
    CoreView,
    CoreDateTimePickerField,
  },

  data() {
    return {
      loading: true,
      salvando: false,
      formValido: true,
      obtendoLocalizacao: false,
      dialogFotoAmpliada: false,
      fotoSelecionada: null,
      dialogConfirmarCancelar: false,
      snapshotFormulario: null,

      comboboxSearch: {
        placa: '',
        motorista: '',
        produtor: '',
        propriedade: '',
        produto: '',
        talhao: '',
        destino: '',
      },

      formulario: {
        id: null,
        apeidapontamentoembarque: null,
        apetipomidia: null,
        dataHora: geraData(),
        apedata: null,
        placa: null,
        apeidplaca: null,
        apeplaca: '',
        motorista: null,
        apeidmotorista: null,
        apemotorista: '',
        contratoMp: '',
        apecontratomp: '',
        produtor: null,
        apeidprodutor: null,
        apeprodutor: '',
        propriedade: null,
        apeidpropriedade: null,
        apepropriedade: '',
        produto: null,
        apeidproduto: null,
        apeproduto: '',
        talhao: null,
        apeidtalhao: null,
        apetalhao: '',
        destino: '',
        apeiddestino: null,
        apedestino: '',
        observacao: '',
        apeobservacao: '',
        localizacao: null,
        apelatitude: null,
        apelongitude: null,
        apeidempresa: null,
        fotos: [],
      },

      autocomplete: {
        frota: [],
        motorista: [],
        produtor: [],
        propriedade: [],
        produto: [],
        talhao: [],
        destino: [],
      },

      rules: {
        dataHora: [(v) => !!v || 'Data e Hora são obrigatórias'],
        placa: [(v) => (v !== null && v !== undefined && String(typeof v === 'object' ? (v.veidescricao || v.veiplaca || '') : v).trim() !== '') || 'Placa é obrigatória'],
        motorista: [(v) => (v !== null && v !== undefined && String(typeof v === 'object' ? (v.pesnome || '') : v).trim() !== '') || 'Motorista é obrigatório'],
        contratoMp: [(v) => (v !== null && v !== undefined && String(v).trim() !== '') || 'Contrato MP é obrigatório'],
        produtor: [(v) => (v !== null && v !== undefined && String(typeof v === 'object' ? (v.pesnome || '') : v).trim() !== '') || 'Produtor é obrigatório'],
        propriedade: [(v) => (v !== null && v !== undefined && String(typeof v === 'object' ? (v.pronome || '') : v).trim() !== '') || 'Propriedade é obrigatória'],
        produto: [(v) => (v !== null && v !== undefined && String(typeof v === 'object' ? (v.prodescricaoFormatada || v.prodescricao || '') : v).trim() !== '') || 'Produto é obrigatório'],
        talhao: [],
        destino: [(v) => (v !== null && v !== undefined && String(typeof v === 'object' ? (v.pronome || v.descricao || v.nome || '') : v).trim() !== '') || 'Destino é obrigatório'],
      },
    };
  },

  computed: {
    alturaCampos() {
      return this.$vuetify.breakpoint.mobile ? 48 : 42;
    },
  },

  methods: {
    // Formatadores para combobox
    $_formatarItemFrota(item) {
      if (item == null) return '';
      if (typeof item === 'object') return item.veidescricao || item.veiplaca || item.placa || item.descricao || '';
      return String(item);
    },

    $_formatarItemPessoa(item) {
      if (item == null) return '';
      if (typeof item === 'object') return item.pesnome || item.pesnomefantasia || item.nome || '';
      return String(item);
    },

    $_formatarItemPropriedade(item) {
      if (item == null) return '';
      if (typeof item === 'object') return item.pronome || item.nome || item.descricao || '';
      return String(item);
    },

    $_formatarItemProduto(item) {
      if (item == null) return '';
      if (typeof item === 'object') return item.prodescricaoFormatada || item.prodescricao || item.descricao || item.nome || '';
      return String(item);
    },

    $_formatarItemTalhao(item) {
      if (item == null) return '';
      if (typeof item === 'object') return item.taldescricaoFormatada || item.taldescricao || item.descricao || item.nome || '';
      return String(item);
    },

    $_formatarItemDestino(item) {
      if (item == null) return '';
      if (typeof item === 'object') return item.pronome || item.descricao || item.nome || '';
      return String(item);
    },

    // Sincronização de texto digitado nos comboboxes
    $_onComboboxBlur(campo) {
      const searchVal = this.comboboxSearch[campo];
      if (searchVal && typeof searchVal === 'string' && searchVal.trim() !== '') {
        const valAtual = this.formulario[campo];
        let textoAtual = '';
        if (typeof valAtual === 'string') {
          textoAtual = valAtual;
        } else if (typeof valAtual === 'object' && valAtual !== null) {
          switch (campo) {
            case 'placa':
              textoAtual = this.$_formatarItemFrota(valAtual);
              break;
            case 'motorista':
            case 'produtor':
              textoAtual = this.$_formatarItemPessoa(valAtual);
              break;
            case 'propriedade':
              textoAtual = this.$_formatarItemPropriedade(valAtual);
              break;
            case 'produto':
              textoAtual = this.$_formatarItemProduto(valAtual);
              break;
            case 'talhao':
              textoAtual = this.$_formatarItemTalhao(valAtual);
              break;
            case 'destino':
              textoAtual = this.$_formatarItemDestino(valAtual);
              break;
            default:
              textoAtual = valAtual.nome || valAtual.descricao || '';
          }
        }
        if (searchVal.trim() !== textoAtual.trim()) {
          this.formulario[campo] = searchVal.trim();
        }
      }
    },

    $_sincronizarCamposDigitados() {
      const campos = ['placa', 'motorista', 'produtor', 'propriedade', 'produto', 'talhao', 'destino'];
      campos.forEach((campo) => {
        this.$_onComboboxBlur(campo);
      });
    },

    $_atualizarComboboxSearch() {
      const campos = ['placa', 'motorista', 'produtor', 'propriedade', 'produto', 'talhao', 'destino'];
      campos.forEach((campo) => {
        const val = this.formulario[campo];
        if (val == null) {
          this.comboboxSearch[campo] = '';
        } else if (typeof val === 'string') {
          this.comboboxSearch[campo] = val;
        } else {
          switch (campo) {
            case 'placa':
              this.comboboxSearch[campo] = this.$_formatarItemFrota(val);
              break;
            case 'motorista':
            case 'produtor':
              this.comboboxSearch[campo] = this.$_formatarItemPessoa(val);
              break;
            case 'propriedade':
              this.comboboxSearch[campo] = this.$_formatarItemPropriedade(val);
              break;
            case 'produto':
              this.comboboxSearch[campo] = this.$_formatarItemProduto(val);
              break;
            case 'talhao':
              this.comboboxSearch[campo] = this.$_formatarItemTalhao(val);
              break;
            case 'destino':
              this.comboboxSearch[campo] = this.$_formatarItemDestino(val);
              break;
            default:
              this.comboboxSearch[campo] = val.nome || val.descricao || '';
          }
        }
      });
    },

    // Filtros de busca personalizados
    $_filtroFrota(item, queryText) {
      if (!queryText) return true;
      const query = queryText.toLowerCase().trim();
      if (typeof item === 'string') return item.toLowerCase().includes(query);
      const placa = (item.veiplaca || '').toLowerCase();
      const marca = (item.veimarca || '').toLowerCase();
      const frota = (item.veifrota || '').toLowerCase();
      const desc = (item.veidescricao || '').toLowerCase();
      return placa.includes(query) || marca.includes(query) || frota.includes(query) || desc.includes(query);
    },

    $_filtroPessoa(item, queryText) {
      if (!queryText) return true;
      const query = queryText.toLowerCase().trim();
      if (typeof item === 'string') return item.toLowerCase().includes(query);
      const nome = (item.pesnome || '').toLowerCase();
      const fantasia = (item.pesnomefantasia || '').toLowerCase();
      const cpf = (item.pescpf || '').replace(/\D/g, '');
      const queryDigitos = query.replace(/\D/g, '');
      return nome.includes(query) || fantasia.includes(query) || (queryDigitos && cpf.includes(queryDigitos));
    },

    $_filtroPropriedade(item, queryText) {
      if (!queryText) return true;
      const query = queryText.toLowerCase().trim();
      const nome = (item.pronome || '').toLowerCase();
      const id = String(item.proidpropriedade || item.id || '');
      return nome.includes(query) || id.includes(query);
    },

    $_filtroProduto(item, queryText) {
      if (!queryText) return true;
      const query = queryText.toLowerCase().trim();
      const desc = (item.prodescricao || '').toLowerCase();
      const cod = (item.procodigo || '').toLowerCase();
      return desc.includes(query) || cod.includes(query);
    },

    $_filtroTalhao(item, queryText) {
      if (!queryText) return true;
      const query = queryText.toLowerCase().trim();
      const desc = (item.taldescricao || '').toLowerCase();
      const cod = (item.talcodigo || '').toLowerCase();
      const formatada = (item.taldescricaoFormatada || '').toLowerCase();
      return desc.includes(query) || cod.includes(query) || formatada.includes(query);
    },

    // GEOLOCALIZAÇÃO
    $_obterLocalizacao() {
      if (!navigator.geolocation) {
        errorHandler('Geolocalização não é suportada pelo seu dispositivo ou navegador.');
        return;
      }

      this.obtendoLocalizacao = true;

      navigator.geolocation.getCurrentPosition(
        (position) => {
          this.obtendoLocalizacao = false;
          const { latitude, longitude } = position.coords;
          this.formulario.localizacao = {
            latitude: Number(latitude.toFixed(6)),
            longitude: Number(longitude.toFixed(6)),

          };
          errorHandler('Localização capturada com sucesso!');
        },
        (error) => {
          this.obtendoLocalizacao = false;
          let msg = 'Erro ao obter localização GPS.';
          if (error.code === 1) {
            msg = 'Permissão de GPS negada. Por favor, ative a localização do seu dispositivo.';
          } else if (error.code === 2) {
            msg = 'Sinal de GPS indisponível no momento.';
          } else if (error.code === 3) {
            msg = 'Tempo limite esgotado ao tentar capturar o GPS.';
          }
          errorHandler(msg);
        },
        {
          enableHighAccuracy: true,
          timeout: 15000,
          maximumAge: 0,
        },
      );
    },

    $_removerLocalizacao() {
      this.formulario.localizacao = null;
    },

    $_abrirMapa() {
      if (this.formulario.localizacao) {
        const { latitude, longitude } = this.formulario.localizacao;
        window.open(`https://www.google.com/maps/search/?api=1&query=${latitude},${longitude}`, '_blank');
      }
    },

    // GESTÃO DE FOTOS
    $_comprimirFoto(file) {
      return new Promise((resolve) => {
        const reader = new FileReader();
        reader.onload = (readerEvent) => {
          const img = new Image();
          img.onload = () => {
            const maxWidth = 1280;
            const maxHeight = 1280;
            let { width, height } = img;

            if (width > height) {
              if (width > maxWidth) {
                height *= maxWidth / width;
                width = maxWidth;
              }
            } else if (height > maxHeight) {
              width *= maxHeight / height;
              height = maxHeight;
            }

            const canvas = document.createElement('canvas');
            canvas.width = width;
            canvas.height = height;
            const ctx = canvas.getContext('2d');
            ctx.drawImage(img, 0, 0, width, height);

            const dataUrl = canvas.toDataURL('image/jpeg', 0.8);
            resolve(dataUrl);
          };
          img.onerror = () => resolve(readerEvent.target.result);
          img.src = readerEvent.target.result;
        };
        reader.onerror = () => resolve(null);
        reader.readAsDataURL(file);
      });
    },

    async $_onFotosSelecionadas(event) {
      const { files } = event.target;
      if (!files || files.length === 0) return;

      const arrayFiles = Array.from(files);
      // eslint-disable-next-line no-restricted-syntax
      for (const file of arrayFiles) {
        // eslint-disable-next-line no-await-in-loop
        const dataUrl = await this.$_comprimirFoto(file);
        if (dataUrl) {
          this.formulario.fotos.push({
            id: Date.now() + Math.random().toString(36).substring(2, 9),
            nome: file.name || 'Foto de Embarque',
            url: dataUrl,
            dataHora: moment().format('DD/MM/YYYY HH:mm:ss'),
          });
        }
      }

      if (this.$refs.inputCamera) {
        this.$refs.inputCamera.value = '';
      }
      if (this.$refs.inputGaleria) {
        this.$refs.inputGaleria.value = '';
      }
    },

    $_abrirGaleria() {
      if (this.$refs.inputGaleria) {
        this.$refs.inputGaleria.click();
      }
    },

    $_cliqueCamera(acao) {
      this.$_sincronizarCamposDigitados();
      sessionStorage.setItem(APONTAMENTO_EMBARQUE_STORAGE.formulario, JSON.stringify(this.formulario));
      sessionStorage.setItem(ROTA_STORAGE.anterior, ROUTE_APONTAMENTO_EMBARQUE_CADASTRO.name);
      sessionStorage.setItem(ROTA_STORAGE.cadastro, 'apontamentoEmbarque');

      if (acao === 'alterar') {
        sessionStorage.setItem(VISITA_INFO_STORAGE.observacao, this.formulario.observacao || '');
        sessionStorage.setItem(VISITA_INFO_STORAGE.titulo, 'Foto Apontamento');
      } else {
        ['observacao', 'titulo', 'idinfo', 'imagem'].forEach((item) => {
          sessionStorage.removeItem(VISITA_INFO_STORAGE[item]);
        });
      }

      this.$router.push({
        ...this.$route,
        name: ROUTE_CAMERA.name,
      });
    },

    $_cliqueGravacao(acao) {
      this.$_sincronizarCamposDigitados();
      sessionStorage.setItem(APONTAMENTO_EMBARQUE_STORAGE.formulario, JSON.stringify(this.formulario));
      sessionStorage.setItem(ROTA_STORAGE.anterior, ROUTE_APONTAMENTO_EMBARQUE_CADASTRO.name);
      sessionStorage.setItem(ROTA_STORAGE.cadastro, 'apontamentoEmbarque');

      if (acao === 'alterar') {
        sessionStorage.setItem(VISITA_INFO_STORAGE.observacao, this.formulario.observacao || '');
        sessionStorage.setItem(VISITA_INFO_STORAGE.titulo, 'Vídeo Apontamento');
      } else {
        ['observacao', 'titulo', 'idinfo', 'imagem'].forEach((item) => {
          sessionStorage.removeItem(VISITA_INFO_STORAGE[item]);
        });
      }

      this.$router.push({
        ...this.$route,
        name: ROUTE_VIDEO.name,
      });
    },

    $_removerFoto(index) {
      this.formulario.fotos.splice(index, 1);
    },

    $_obterMidiaUrl(foto) {
      if (!foto) return '';
      const blob = foto.blob || getVideoBlob(foto.id);
      if (blob instanceof Blob) {
        return URL.createObjectURL(blob);
      }
      return foto.url || foto.src || '';
    },

    $_visualizarFoto(foto) {
      this.fotoSelecionada = {
        ...foto,
        mediaUrl: this.$_obterMidiaUrl(foto),
      };
      this.dialogFotoAmpliada = true;
    },

    // CANCELAMENTO
    $_temAlteracoes() {
      if (!this.snapshotFormulario) return false;
      return JSON.stringify(this.formulario) !== this.snapshotFormulario;
    },

    $_cancelar() {
      this.$_sincronizarCamposDigitados();
      if (this.$_temAlteracoes()) {
        this.dialogConfirmarCancelar = true;
      } else {
        this.$_confirmarSair();
      }
    },

    $_confirmarSair() {
      this.dialogConfirmarCancelar = false;
      sessionStorage.removeItem(APONTAMENTO_EMBARQUE_STORAGE.formulario);
      sessionStorage.removeItem(APONTAMENTO_EMBARQUE_STORAGE.itemSelecionado);
      sessionStorage.removeItem(APONTAMENTO_EMBARQUE_STORAGE.campoSelecao);
      sessionStorage.removeItem('APONTAMENTO_EMBARQUE_SNAPSHOT');
      this.$router.replace({ name: ROUTE_APONTAMENTO_EMBARQUE.name }).catch(() => {});
    },

    async $_salvaDados() {
      this.$_sincronizarCamposDigitados();

      if (!this.$refs.form.validate()) {
        errorHandler('Por favor, preencha todos os campos obrigatórios.');
        return;
      }

      this.salvando = true;

      try {
        const dataAlteracao = geraData();

        // 1. Obter empresa
        const emp = (await db.empresa.get(1)) || (await db.empresa.toCollection().first()) || {};

        // 2. Extrai identificadores e descrições dos objetos
        const veiculoObj = typeof this.formulario.placa === 'object' && this.formulario.placa !== null
          ? this.formulario.placa
          : this.autocomplete.frota.find((f) => f.id === this.formulario.placa || f.veiidveiculo === this.formulario.placa || f.veiplaca === this.formulario.placa) || null;

        const motoristaObj = typeof this.formulario.motorista === 'object' && this.formulario.motorista !== null
          ? this.formulario.motorista
          : this.autocomplete.motorista.find((m) => m.id === this.formulario.motorista || m.pesidpessoa === this.formulario.motorista || m.pesnome === this.formulario.motorista) || null;

        const produtorObj = typeof this.formulario.produtor === 'object' && this.formulario.produtor !== null
          ? this.formulario.produtor
          : this.autocomplete.produtor.find((p) => p.id === this.formulario.produtor || p.pesidpessoa === this.formulario.produtor || p.pesnome === this.formulario.produtor) || null;

        const propriedadeObj = typeof this.formulario.propriedade === 'object' && this.formulario.propriedade !== null
          ? this.formulario.propriedade
          : this.autocomplete.propriedade.find((pr) => pr.id === this.formulario.propriedade || pr.proidpropriedade === this.formulario.propriedade || pr.pronome === this.formulario.propriedade) || null;

        const produtoObj = typeof this.formulario.produto === 'object' && this.formulario.produto !== null
          ? this.formulario.produto
          : this.autocomplete.produto.find((pd) => pd.id === this.formulario.produto || pd.proidproduto === this.formulario.produto || pd.prodescricao === this.formulario.produto) || null;

        const talhaoObj = typeof this.formulario.talhao === 'object' && this.formulario.talhao !== null
          ? this.formulario.talhao
          : this.autocomplete.talhao.find((t) => t.id === this.formulario.talhao || t.talidtalhao === this.formulario.talhao || t.taldescricao === this.formulario.talhao) || null;

        // 3. Montar cada campo solicitado:
        // apeidapontamentoembarque
        const apeidapontamentoembarque = this.formulario.apeidapontamentoembarque != null && this.formulario.apeidapontamentoembarque !== ''
          ? Number(this.formulario.apeidapontamentoembarque)
          : null;

        const fotosCompletas = (this.formulario.fotos || []).map((f) => {
          const videoBlob = f.blob || getVideoBlob(f.id);
          return {
            ...f,
            ...(videoBlob ? { blob: videoBlob } : {}),
          };
        });

        // apetipomidia
        let apetipomidia = this.formulario.apetipomidia || null;
        if (fotosCompletas.length > 0) {
          const temVideo = fotosCompletas.some(
            (f) => f.tipo === 'video' || f.blob || (typeof f.url === 'string' && f.url.startsWith('data:video')),
          );
          const temFoto = fotosCompletas.some(
            (f) => f.tipo !== 'video' && !f.blob && !(typeof f.url === 'string' && f.url.startsWith('data:video')),
          );
          if (temVideo && temFoto) {
            apetipomidia = 'image,video';
          } else if (temVideo) {
            apetipomidia = 'video';
          } else if (temFoto) {
            apetipomidia = 'image';
          } else {
            apetipomidia = null;
          }
        } else {
          apetipomidia = null;
        }

        // apedata
        const apedata = this.formulario.dataHora || this.formulario.apedata || dataAlteracao;

        // apeidplaca e apeplaca
        const apeidplaca = Number(veiculoObj?.veiidveiculo || veiculoObj?.id) || (typeof this.formulario.placa === 'number' ? this.formulario.placa : null);
        const apeplaca = (
          veiculoObj?.veiplaca
          || veiculoObj?.veidescricao
          || veiculoObj?.placa
          || veiculoObj?.descricao
          || (typeof this.formulario.placa === 'string' ? this.formulario.placa : '')
          || ''
        ).trim();

        // apeidmotorista e apemotorista
        const apeidmotorista = Number(motoristaObj?.pesidpessoa || motoristaObj?.id) || (typeof this.formulario.motorista === 'number' ? this.formulario.motorista : null);
        const apemotorista = (
          motoristaObj?.pesnome
          || motoristaObj?.nome
          || (typeof this.formulario.motorista === 'string' ? this.formulario.motorista : '')
          || ''
        ).trim();

        // apecontratomp
        const apecontratomp = String(this.formulario.contratoMp || this.formulario.apecontratomp || '').trim();

        // apeidprodutor e apeprodutor
        const apeidprodutor = Number(produtorObj?.pesidpessoa || produtorObj?.id) || (typeof this.formulario.produtor === 'number' ? this.formulario.produtor : null);
        const apeprodutor = (
          produtorObj?.pesnome
          || produtorObj?.nome
          || (typeof this.formulario.produtor === 'string' ? this.formulario.produtor : '')
          || ''
        ).trim();

        // apeidpropriedade e apepropriedade
        const apeidpropriedade = Number(propriedadeObj?.proidpropriedade || propriedadeObj?.id) || (typeof this.formulario.propriedade === 'number' ? this.formulario.propriedade : null);
        const apepropriedade = (
          propriedadeObj?.pronome
          || propriedadeObj?.nome
          || (typeof this.formulario.propriedade === 'string' ? this.formulario.propriedade : '')
          || ''
        ).trim();

        // apeidproduto e apeproduto
        const apeidproduto = Number(produtoObj?.proidproduto || produtoObj?.id) || (typeof this.formulario.produto === 'number' ? this.formulario.produto : null);
        const apeproduto = (
          produtoObj?.prodescricaoFormatada
          || produtoObj?.prodescricao
          || produtoObj?.descricao
          || produtoObj?.nome
          || (typeof this.formulario.produto === 'string' ? this.formulario.produto : '')
          || ''
        ).trim();

        // apeidtalhao e apetalhao
        const apeidtalhao = Number(talhaoObj?.talidtalhao || talhaoObj?.id) || (typeof this.formulario.talhao === 'number' ? this.formulario.talhao : null);
        const apetalhao = (
          talhaoObj?.taldescricaoFormatada
          || talhaoObj?.taldescricao
          || talhaoObj?.descricao
          || (typeof this.formulario.talhao === 'string' ? this.formulario.talhao : '')
          || ''
        ).trim();

        // apeiddestino e apedestino
        let apeiddestino = null;
        let apedestino = '';
        if (typeof this.formulario.destino === 'object' && this.formulario.destino !== null) {
          apeiddestino = Number(this.formulario.destino.proidpropriedade || this.formulario.destino.id || this.formulario.destino.apeiddestino) || null;
          apedestino = String(this.formulario.destino.pronome || this.formulario.destino.descricao || this.formulario.destino.nome || '').trim();
        } else {
          apedestino = String(this.formulario.destino || '').trim();
          const propDestino = this.autocomplete.propriedade.find(
            (p) => p.pronome && p.pronome.trim().toLowerCase() === apedestino.toLowerCase(),
          );
          if (propDestino) {
            apeiddestino = Number(propDestino.proidpropriedade || propDestino.id) || null;
          } else if (this.formulario.apeiddestino) {
            apeiddestino = Number(this.formulario.apeiddestino) || null;
          }
        }

        // apeobservacao
        const apeobservacao = String(this.formulario.observacao || this.formulario.apeobservacao || '').trim();

        // apelatitude e apelongitude
        let apelatitude = null;
        if (this.formulario.localizacao?.latitude != null) {
          apelatitude = Number(this.formulario.localizacao.latitude);
        } else if (this.formulario.apelatitude != null) {
          apelatitude = Number(this.formulario.apelatitude);
        }

        let apelongitude = null;
        if (this.formulario.localizacao?.longitude != null) {
          apelongitude = Number(this.formulario.localizacao.longitude);
        } else if (this.formulario.apelongitude != null) {
          apelongitude = Number(this.formulario.apelongitude);
        }

        // apeidempresa
        const apeidempresa = Number(
          this.formulario.apeidempresa
          || veiculoObj?.veiidempresa
          || propriedadeObj?.proidempresa
          || emp.empidempresa
          || emp.id
          || sessionStorage.getItem('user:empidempresa')
          || 1,
        );

        const dadosParaSalvar = {
          // Identificação e dados principais
          apeidapontamentoembarque,
          apetipomidia,
          apedata,
          apeidplaca,
          apeplaca,
          apeidmotorista,
          apemotorista,
          apecontratomp,
          apeidprodutor,
          apeprodutor,
          apeidpropriedade,
          apepropriedade,
          apeidproduto,
          apeproduto,
          apeidtalhao,
          apetalhao,
          apeiddestino,
          apedestino,
          apeobservacao,
          apelatitude,
          apelongitude,
          apeidempresa,

          // Metadados de sincronização
          apedatanuvem: this.formulario.apedatanuvem || null,
          apedataalteracao: dataAlteracao,
          apeidapontamentonuvem: this.formulario.apeidapontamentonuvem || this.formulario.apeidnuvem || null,
          apeenviado: this.formulario.apeenviado || 0,
          enviado: this.formulario.enviado || 0,

          // Anexos e GPS (únicos necessários daquela lista)
          localizacao: this.formulario.localizacao || null,
          fotos: fotosCompletas,
        };

        // 1. Salvar apenas no Dexie (apontamentoembarque)
        if (db.apontamentoembarque) {
          try {
            if (this.formulario.id) {
              dadosParaSalvar.id = this.formulario.id;
              await db.apontamentoembarque.put(dadosParaSalvar);
            } else {
              const idInserido = await db.apontamentoembarque.add(dadosParaSalvar);
              dadosParaSalvar.id = idInserido;
              this.formulario.id = idInserido;
            }
          } catch (dexieErr) {
            console.error('Erro ao salvar no Dexie apontamentoembarque:', dexieErr);
            throw dexieErr;
          }
        }

        // 2. Persistência auxiliar no localStorage para suporte offline instantâneo
        try {
          const chaveLs = 'APONTAMENTOS_EMBARQUE_LISTA';
          const listaAtual = JSON.parse(localStorage.getItem(chaveLs) || '[]');
          const idx = listaAtual.findIndex((item) => String(item.id) === String(dadosParaSalvar.id));
          const itemParaLs = {
            ...dadosParaSalvar,
            fotos: fotosCompletas.map((f) => {
              const { blob, ...semBlob } = f;
              return semBlob;
            }),
          };
          if (idx >= 0) {
            listaAtual[idx] = itemParaLs;
          } else {
            listaAtual.unshift(itemParaLs);
          }
          localStorage.setItem(chaveLs, JSON.stringify(listaAtual));
        } catch (lsErr) {
          console.warn('Aviso: Erro ao sincronizar no localStorage:', lsErr);
        }

        fotosCompletas.forEach((f) => {
          removeVideoBlob(f.id);
        });

        sessionStorage.removeItem(APONTAMENTO_EMBARQUE_STORAGE.formulario);
        sessionStorage.removeItem(APONTAMENTO_EMBARQUE_STORAGE.itemSelecionado);
        sessionStorage.removeItem(APONTAMENTO_EMBARQUE_STORAGE.campoSelecao);
        sessionStorage.removeItem('APONTAMENTO_EMBARQUE_SNAPSHOT');
        errorHandler('Apontamento de embarque salvo com sucesso!');
        this.$router.replace({ name: ROUTE_APONTAMENTO_EMBARQUE.name }).catch(() => {});
      } catch (err) {
        console.error('Erro ao salvar apontamento de embarque:', err);
        errorHandler('Erro ao salvar apontamento de embarque.');
      } finally {
        this.salvando = false;
      }
    },

    // CARREGAMENTO DOS DADOS DO BANCO DEXIE
    async $_findDb() {
      try {
        // Veículos / Frotas
        const veiculos = await db.veiculo.toArray();
        const veiculosAtivos = veiculos.filter((v) => !v.veideletar);
        this.autocomplete.frota = veiculosAtivos.map((v) => {
          const placa = (v.veiplaca || '').trim();
          const frota = (v.veifrota || '').trim();
          const marca = (v.veimarca || '').trim();
          let desc = placa;
          if (frota && placa) desc = `${placa} - ${frota}`;
          else if (!desc) desc = frota || marca || `Veículo #${v.id || v.veiidveiculo}`;
          if (marca && !desc.includes(marca)) desc += ` (${marca})`;

          return {
            ...v,
            id: v.id || v.veiidveiculo,
            veiidveiculo: v.veiidveiculo || v.id,
            veidescricao: desc,
          };
        }).sort((a, b) => (a.veidescricao || '').localeCompare(b.veidescricao || ''));

        // Pessoas (Motoristas e Produtores)
        const pessoas = await db.pessoa.toArray();
        const pessoasAtivas = pessoas.filter((p) => !p.pesdeletar);
        const listaPessoas = pessoasAtivas.map((p) => ({
          ...p,
          id: p.id || p.pesidpessoa,
          pesidpessoa: p.pesidpessoa || p.id,
          pesnome: p.pesnome || p.pesnomefantasia || 'Sem nome',
        })).sort((a, b) => (a.pesnome || '').localeCompare(b.pesnome || ''));

        this.autocomplete.motorista = listaPessoas;
        this.autocomplete.produtor = listaPessoas;

        // Propriedades
        const propriedades = await db.propriedade.toArray();
        const isProDeletado = (p) => {
          const val = String(p.prodeletar ?? '').toUpperCase().trim();
          return val === 'S' || val === 'TRUE' || p.prodeletar === true || p.prodeletar === 1;
        };
        const propriedadesValidas = propriedades.filter((p) => !isProDeletado(p));
        this.autocomplete.propriedade = propriedadesValidas.map((p) => ({
          ...p,
          id: p.id || p.proidpropriedade,
          proidpropriedade: p.proidpropriedade || p.id,
          pronome: p.pronome || `Propriedade #${p.id || p.proidpropriedade}`,
        })).sort((a, b) => (a.pronome || '').localeCompare(b.pronome || ''));

        // Produtos
        const produtos = await db.produto.toArray();
        this.autocomplete.produto = produtos.map((p) => {
          const proId = p.proidproduto || p.id;
          const descOriginal = p.prodescricao || '';
          const codigo = p.procodigo || '';
          return {
            ...p,
            id: proId,
            proidproduto: proId,
            procodigo: codigo,
            prodescricaoOriginal: descOriginal,
            prodescricao: descOriginal,
            prodescricaoFormatada: codigo ? `${codigo} - ${descOriginal}` : descOriginal,
          };
        }).sort((a, b) => (a.prodescricao || '').localeCompare(b.prodescricao || ''));

        // Talhões
        const talhoes = await db.talhao.toArray();
        this.autocomplete.talhao = talhoes.map((t) => {
          const talId = t.talidtalhao || t.id;
          const desc = t.taldescricao || '';
          const cod = t.talcodigo || '';
          return {
            ...t,
            id: talId,
            talidtalhao: talId,
            talcodigo: cod,
            taldescricao: desc,
            taldescricaoFormatada: cod ? `${cod} - ${desc}` : desc,
          };
        }).sort((a, b) => (a.taldescricaoFormatada || '').localeCompare(b.taldescricaoFormatada || ''));

        // Sugestões de Destinos (Propriedades + Destinos padrão de embarque)
        const nomesPropriedades = this.autocomplete.propriedade.map((p) => p.pronome).filter(Boolean);
        const destinosPadrao = ['Armazém Geral', 'Silo Central', 'Cooperativa', 'Porto', 'Indústria / Fábrica'];
        this.autocomplete.destino = Array.from(new Set([...destinosPadrao, ...nomesPropriedades]));

        // Restaura registros ou edição se necessário
        await this.$_recuperarEdicaoOuRascunho();
        this.$_recuperarFormulario();
      } catch (err) {
        console.warn('Erro ao carregar dados do Dexie:', err);
      } finally {
        this.loading = false;
        const snapshotSalvo = sessionStorage.getItem('APONTAMENTO_EMBARQUE_SNAPSHOT');
        if (snapshotSalvo) {
          this.snapshotFormulario = snapshotSalvo;
        } else {
          this.snapshotFormulario = JSON.stringify(this.formulario);
          sessionStorage.setItem('APONTAMENTO_EMBARQUE_SNAPSHOT', this.snapshotFormulario);
        }
      }
    },

    // Métodos para a Tela de Seleção (aberta via ícone do btn-auto-complete)
    $_abrirTelaSelecao(campo) {
      this.$_sincronizarCamposDigitados();
      sessionStorage.setItem(APONTAMENTO_EMBARQUE_STORAGE.formulario, JSON.stringify(this.formulario));
      sessionStorage.setItem(APONTAMENTO_EMBARQUE_STORAGE.campoSelecao, campo);
      sessionStorage.setItem(ROTA_STORAGE.anterior, ROUTE_APONTAMENTO_EMBARQUE_CADASTRO.name);
      if (this.$route.name !== ROUTE_APONTAMENTO_EMBARQUE_SELECAO.name) {
        this.$router.push({
          name: ROUTE_APONTAMENTO_EMBARQUE_SELECAO.name,
          query: { campo },
        }).catch((err) => {
          if (err && err.name !== 'NavigationDuplicated') {
            throw err;
          }
        });
      }
    },

    $_recuperarFormulario() {
      try {
        const formStr = sessionStorage.getItem(APONTAMENTO_EMBARQUE_STORAGE.formulario);
        if (formStr) {
          const formSalvo = JSON.parse(formStr);
          this.formulario = {
            ...this.formulario,
            ...formSalvo,
          };
          if (Array.isArray(this.formulario.fotos)) {
            this.formulario.fotos = this.formulario.fotos.map((f) => {
              if (f.tipo === 'video' && !f.blob && getVideoBlob(f.id)) {
                return {
                  ...f,
                  blob: getVideoBlob(f.id),
                };
              }
              return f;
            });
          }
        }

        const itemSelecionadoStr = sessionStorage.getItem(APONTAMENTO_EMBARQUE_STORAGE.itemSelecionado)
          || sessionStorage.getItem(MANUTENCAO_STORAGE.itemSelecionado);
        if (itemSelecionadoStr) {
          const { campo, item } = JSON.parse(itemSelecionadoStr);
          if (campo === 'placa' || campo === 'frota') {
            if (item) {
              const idVei = item.veiidveiculo || item.id;
              const placa = item.veiplaca;
              const match = (idVei != null ? this.autocomplete.frota.find(
                (v) => (v.veiidveiculo && v.veiidveiculo === idVei) || (v.id && v.id === idVei),
              ) : null)
                || (placa ? this.autocomplete.frota.find(
                  (v) => v.veiplaca && v.veiplaca.trim().toUpperCase() === placa.trim().toUpperCase(),
                ) : null);
              if (match) {
                this.formulario.placa = match;
              } else {
                this.formulario.placa = item;
                this.autocomplete.frota.unshift(item);
              }
            } else {
              this.formulario.placa = null;
            }
          } else if (campo === 'motorista') {
            if (item) {
              const idPes = item.pesidpessoa || item.id;
              const nome = item.pesnome;
              const match = (idPes != null ? this.autocomplete.motorista.find(
                (m) => (m.pesidpessoa && m.pesidpessoa === idPes) || (m.id && m.id === idPes),
              ) : null)
                || (nome ? this.autocomplete.motorista.find(
                  (m) => m.pesnome && m.pesnome.trim().toLowerCase() === nome.trim().toLowerCase(),
                ) : null);
              if (match) {
                this.formulario.motorista = match;
              } else {
                this.formulario.motorista = item;
                this.autocomplete.motorista.unshift(item);
              }
            } else {
              this.formulario.motorista = null;
            }
          } else if (campo === 'produtor') {
            if (item) {
              const idPes = item.pesidpessoa || item.id;
              const nome = item.pesnome;
              const match = (idPes != null ? this.autocomplete.produtor.find(
                (p) => (p.pesidpessoa && p.pesidpessoa === idPes) || (p.id && p.id === idPes),
              ) : null)
                || (nome ? this.autocomplete.produtor.find(
                  (p) => p.pesnome && p.pesnome.trim().toLowerCase() === nome.trim().toLowerCase(),
                ) : null);
              if (match) {
                this.formulario.produtor = match;
              } else {
                this.formulario.produtor = item;
                this.autocomplete.produtor.unshift(item);
              }
            } else {
              this.formulario.produtor = null;
            }
          } else if (campo === 'propriedade') {
            if (item) {
              const idPro = item.proidpropriedade || item.id;
              const nome = item.pronome;
              const match = (idPro != null ? this.autocomplete.propriedade.find(
                (pr) => (pr.proidpropriedade && pr.proidpropriedade === idPro) || (pr.id && pr.id === idPro),
              ) : null)
                || (nome ? this.autocomplete.propriedade.find(
                  (pr) => pr.pronome && pr.pronome.trim().toLowerCase() === nome.trim().toLowerCase(),
                ) : null);
              if (match) {
                this.formulario.propriedade = match;
              } else {
                this.formulario.propriedade = item;
                this.autocomplete.propriedade.unshift(item);
              }
            } else {
              this.formulario.propriedade = null;
            }
          } else if (campo === 'produto') {
            if (item) {
              const idProd = item.proidproduto || item.id;
              const desc = item.prodescricao;
              const match = (idProd != null ? this.autocomplete.produto.find(
                (pd) => (pd.proidproduto && pd.proidproduto === idProd) || (pd.id && pd.id === idProd),
              ) : null)
                || (desc ? this.autocomplete.produto.find(
                  (pd) => pd.prodescricao && pd.prodescricao.trim().toLowerCase() === desc.trim().toLowerCase(),
                ) : null);
              if (match) {
                this.formulario.produto = match;
              } else {
                this.formulario.produto = item;
                this.autocomplete.produto.unshift(item);
              }
            } else {
              this.formulario.produto = null;
            }
          } else if (campo === 'talhao') {
            if (item) {
              const idTal = item.talidtalhao || item.id;
              const desc = item.taldescricao;
              const cod = item.talcodigo;
              const match = (idTal != null ? this.autocomplete.talhao.find(
                (t) => (t.talidtalhao && t.talidtalhao === idTal) || (t.id && t.id === idTal),
              ) : null)
                || (cod ? this.autocomplete.talhao.find(
                  (t) => t.talcodigo && String(t.talcodigo).trim() === String(cod).trim(),
                ) : null)
                || (desc ? this.autocomplete.talhao.find(
                  (t) => t.taldescricao && t.taldescricao.trim().toLowerCase() === desc.trim().toLowerCase(),
                ) : null);
              if (match) {
                this.formulario.talhao = match;
              } else {
                this.formulario.talhao = item;
                this.autocomplete.talhao.unshift(item);
              }
            } else {
              this.formulario.talhao = null;
            }
          }
          sessionStorage.removeItem(APONTAMENTO_EMBARQUE_STORAGE.itemSelecionado);
          sessionStorage.removeItem(MANUTENCAO_STORAGE.itemSelecionado);
        }

        sessionStorage.removeItem(APONTAMENTO_EMBARQUE_STORAGE.campoSelecao);
        sessionStorage.removeItem(MANUTENCAO_STORAGE.campoSelecao);
        sessionStorage.setItem(APONTAMENTO_EMBARQUE_STORAGE.formulario, JSON.stringify(this.formulario));
        this.$_atualizarComboboxSearch();

        this.$nextTick(() => {
          if (this.$refs.form) {
            this.$refs.form.resetValidation();
          }
        });
      } catch (e) {
        console.warn('Erro ao recuperar formulário de apontamento de embarque:', e);
      }
    },

    async $_recuperarEdicaoOuRascunho() {
      const idEditar = this.$route.query.id || this.$route.params.id;

      if (idEditar) {
        let registro = null;
        if (db.apontamentoembarque) {
          try {
            registro = await db.apontamentoembarque.get(Number(idEditar) || idEditar);
            if (!registro && !Number.isNaN(Number(idEditar))) {
              registro = await db.apontamentoembarque.where('apeidapontamentoembarque').equals(Number(idEditar)).first();
            }
          } catch (e) {
            // ignore
          }
        }
        if (!registro) {
          try {
            const lista = JSON.parse(localStorage.getItem('APONTAMENTOS_EMBARQUE_LISTA') || '[]');
            registro = lista.find((item) => String(item.id) === String(idEditar) || String(item.apeidapontamentoembarque) === String(idEditar));
          } catch (e) {
            // ignore
          }
        }

        if (registro) {
          this.formulario.id = registro.id;
          this.formulario.apeidapontamentoembarque = registro.apeidapontamentoembarque || null;
          this.formulario.apetipomidia = registro.apetipomidia || null;
          this.formulario.dataHora = registro.apedata || registro.dataHora || geraData();
          this.formulario.apedata = registro.apedata || null;
          this.formulario.contratoMp = registro.apecontratomp || registro.contratoMp || '';
          this.formulario.apecontratomp = registro.apecontratomp || '';
          this.formulario.destino = registro.apedestino || registro.destino || '';
          this.formulario.apedestino = registro.apedestino || '';
          this.formulario.apeiddestino = registro.apeiddestino || null;
          this.formulario.observacao = registro.apeobservacao || registro.observacao || '';
          this.formulario.apeobservacao = registro.apeobservacao || '';
          this.formulario.apelatitude = registro.apelatitude != null ? Number(registro.apelatitude) : null;
          this.formulario.apelongitude = registro.apelongitude != null ? Number(registro.apelongitude) : null;
          this.formulario.apeidempresa = registro.apeidempresa || null;
          this.formulario.localizacao = registro.localizacao || (
            registro.apelatitude != null && registro.apelongitude != null
              ? {
                latitude: Number(registro.apelatitude),
                longitude: Number(registro.apelongitude),
                precisao: registro.precisao || 0,
                dataHora: registro.apedata || moment().format('DD/MM/YYYY HH:mm:ss'),
              }
              : null
          );
          this.formulario.fotos = (registro.fotos || []).map((f) => {
            if (f.blob && f.id) {
              setVideoBlob(f.id, f.blob);
            }
            return f;
          });

          // Reconectar relacionamentos com o autocomplete
          const idVei = registro.apeidplaca || registro.idVeiculo;
          const placaStr = registro.apeplaca || registro.placa;
          if (idVei || placaStr) {
            this.formulario.placa = (idVei ? this.autocomplete.frota.find(
              (f) => (f.id === idVei || f.veiidveiculo === idVei),
            ) : null)
              || (placaStr ? this.autocomplete.frota.find(
                (f) => (f.veiplaca && f.veiplaca.toLowerCase() === placaStr.toLowerCase())
                  || (f.veidescricao && f.veidescricao.toLowerCase() === placaStr.toLowerCase()),
              ) : null)
              || registro.veiculoObj || placaStr;
          }

          const idMotorista = registro.apeidmotorista || registro.idMotorista;
          const motoristaStr = registro.apemotorista || registro.motorista;
          if (idMotorista || motoristaStr) {
            this.formulario.motorista = (idMotorista ? this.autocomplete.motorista.find(
              (m) => (m.id === idMotorista || m.pesidpessoa === idMotorista),
            ) : null)
              || (motoristaStr ? this.autocomplete.motorista.find(
                (m) => m.pesnome && m.pesnome.toLowerCase() === motoristaStr.toLowerCase(),
              ) : null)
              || registro.motoristaObj || motoristaStr;
          }

          const idProdutor = registro.apeidprodutor || registro.idProdutor;
          const produtorStr = registro.apeprodutor || registro.produtor;
          if (idProdutor || produtorStr) {
            this.formulario.produtor = (idProdutor ? this.autocomplete.produtor.find(
              (p) => (p.id === idProdutor || p.pesidpessoa === idProdutor),
            ) : null)
              || (produtorStr ? this.autocomplete.produtor.find(
                (p) => p.pesnome && p.pesnome.toLowerCase() === produtorStr.toLowerCase(),
              ) : null)
              || registro.produtorObj || produtorStr;
          }

          const idPropriedade = registro.apeidpropriedade || registro.idPropriedade;
          const propriedadeStr = registro.apepropriedade || registro.propriedade;
          if (idPropriedade || propriedadeStr) {
            this.formulario.propriedade = (idPropriedade ? this.autocomplete.propriedade.find(
              (pr) => (pr.id === idPropriedade || pr.proidpropriedade === idPropriedade),
            ) : null)
              || (propriedadeStr ? this.autocomplete.propriedade.find(
                (pr) => pr.pronome && pr.pronome.toLowerCase() === propriedadeStr.toLowerCase(),
              ) : null)
              || registro.propriedadeObj || propriedadeStr;
          }

          const idProduto = registro.apeidproduto || registro.idProduto;
          const produtoStr = registro.apeproduto || registro.produto;
          if (idProduto || produtoStr) {
            this.formulario.produto = (idProduto ? this.autocomplete.produto.find(
              (pd) => (pd.id === idProduto || pd.proidproduto === idProduto),
            ) : null)
              || (produtoStr ? this.autocomplete.produto.find(
                (pd) => (pd.prodescricao && pd.prodescricao.toLowerCase() === produtoStr.toLowerCase())
                  || (pd.prodescricaoFormatada && pd.prodescricaoFormatada.toLowerCase() === produtoStr.toLowerCase()),
              ) : null)
              || registro.produtoObj || produtoStr;
          }

          const idTalhao = registro.apeidtalhao || registro.idTalhao;
          const talhaoStr = registro.apetalhao || registro.talhao;
          if (idTalhao || talhaoStr) {
            this.formulario.talhao = (idTalhao ? this.autocomplete.talhao.find(
              (t) => (t.id === idTalhao || t.talidtalhao === idTalhao),
            ) : null)
              || (talhaoStr ? this.autocomplete.talhao.find(
                (t) => (t.taldescricao && t.taldescricao.toLowerCase() === talhaoStr.toLowerCase())
                  || (t.taldescricaoFormatada && t.taldescricaoFormatada.toLowerCase() === talhaoStr.toLowerCase()),
              ) : null)
              || registro.talhaoObj || talhaoStr;
          }

          this.$_atualizarComboboxSearch();
        }
      }
    },
  },

  created() {
    sessionStorage.setItem(ROTA_STORAGE.cadastro, 'apontamentoEmbarque');
    this.$_findDb();
  },
};
</script>

<style scoped>
.center {
  width: 100%;
  max-width: 600px;
  margin: 0 auto;
  padding: 16px 12px 40px 12px;
}

.linha {
  width: 100%;
}

.secao-anexos {
  background-color: #fafafa;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  padding: 12px;
}

.card-localizacao {
  border-color: #c8e6c9 !important;
  border-radius: 6px;
}

.fotos-galeria-container {
  width: 100%;
}

.foto-item-wrapper {
  position: relative;
}

.foto-card {
  position: relative;
  border-radius: 8px;
  overflow: hidden;
  cursor: pointer;
  border: 1px solid #cfd8dc;
  transition: transform 0.15s ease-in-out;
}

.foto-card:hover {
  transform: scale(1.03);
}

.foto-miniatura {
  border-radius: 6px;
}

.btn-fechar-foto {
  position: absolute;
  top: 2px;
  right: 2px;
  background-color: rgba(211, 47, 47, 0.85) !important;
}

.divinferior {
  display: flex;
  justify-content: space-between;
  gap: 16px;
  margin-top: 24px;
  margin-bottom: 24px;
  width: 100%;
}

.botaoinferior {
  color: white !important;
  font-weight: bold;
  flex: 1;
}

.botaocancelar {
  background-color: #757575 !important;
}

.botaosalvar {
  background-color: #4caf50 !important;
}

.linha {
  display: flex;
  justify-content: space-around;
  margin-bottom: 8px;
}

.botaocamera {
  margin: 8px;
  min-width: 64px !important;
  height: 54px !important;
  border-radius: 8px;
}

::v-deep .v-input__icon--append .v-icon {
  cursor: pointer;
}
</style>
